import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IVideoMetaData } from 'app/shared/model/video-meta-data.model';
import { getEntities as getVideoMetaData } from 'app/entities/video-meta-data/video-meta-data.reducer';
import { getEntity, updateEntity, createEntity, reset } from './video-meta-data-keywords.reducer';
import { IVideoMetaDataKeywords } from 'app/shared/model/video-meta-data-keywords.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IVideoMetaDataKeywordsUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const VideoMetaDataKeywordsUpdate = (props: IVideoMetaDataKeywordsUpdateProps) => {
  const [videoMetaDataId, setVideoMetaDataId] = useState('0');
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { videoMetaDataKeywordsEntity, videoMetaData, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/video-meta-data-keywords');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getVideoMetaData();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...videoMetaDataKeywordsEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.videoMetaDataKeywords.home.createOrEditLabel">Create or edit a VideoMetaDataKeywords</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : videoMetaDataKeywordsEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="video-meta-data-keywords-id">ID</Label>
                  <AvInput id="video-meta-data-keywords-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="keywordNameLabel" for="video-meta-data-keywords-keywordName">
                  Keyword Name
                </Label>
                <AvField id="video-meta-data-keywords-keywordName" type="text" name="keywordName" />
              </AvGroup>
              <AvGroup>
                <Label for="video-meta-data-keywords-videoMetaData">Video Meta Data</Label>
                <AvInput id="video-meta-data-keywords-videoMetaData" type="select" className="form-control" name="videoMetaData.id">
                  <option value="" key="0" />
                  {videoMetaData
                    ? videoMetaData.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/video-meta-data-keywords" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  videoMetaData: storeState.videoMetaData.entities,
  videoMetaDataKeywordsEntity: storeState.videoMetaDataKeywords.entity,
  loading: storeState.videoMetaDataKeywords.loading,
  updating: storeState.videoMetaDataKeywords.updating,
  updateSuccess: storeState.videoMetaDataKeywords.updateSuccess,
});

const mapDispatchToProps = {
  getVideoMetaData,
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VideoMetaDataKeywordsUpdate);
